<template>
  <div class="Mrp-time defaultTitleTS flex items-center">
    <a-radio-group
      v-if="show"
      v-model:value="activeBtn"
      size="large"
      @change="selectTime"
    >
      <a-radio-button
        v-for="item in btnList"
        :key="item.id"
        :value="item.id"
        class="cursor-pointer"
        >{{ item.name }}</a-radio-button
      >
    </a-radio-group>
    <el-config-provider :locale="locale">
      <template v-if="!isDateRangePicker">
        <el-date-picker
          style="
            height: 30px;
            width: 100px;
            border-radius: 5px;
            padding-left: 5px;
          "
          v-model="time[0]"
          type="date"
          :placeholder="placeholderList[0]"
          :locale="locale"
          format="YYYY/MM/DD"
          valueFormat="YYYY-MM-DD"
          :disabled-date="(current) => current &&time[1]&& (isCheckToday?current >  dayjs(time[1]): current >=  dayjs(time[1]))"
          @change="
            (v) => {
              time[1] = undefined;
              timeChange(time);
            }
          "
        />
        <span style="padding: 0 3px">-</span>
        <el-date-picker
          style="height: 30px; width: 100px; border-radius: 5px"
          v-model="time[1]"
          type="date"
          :placeholder="placeholderList[1]"
          :locale="locale"
          format="YYYY/MM/DD"
          valueFormat="YYYY-MM-DD"
          :disabled-date="(current) => current &&time[0]&& (isCheckToday?current <  dayjs(time[0]): current <=  dayjs(time[0]))"
          @change="(v) => timeChange(time)"
        />
      </template>

      <el-date-picker
        v-else
        style="height: 30px; width: 210px; border-radius: 5px; margin-left: 5px"
        v-model="time"
        type="daterange"
        :placeholder="placeholderList"
        format="YYYY/MM/DD"
        valueFormat="YYYY-MM-DD"
        range-separator="-"
        start-placeholder="开始时间"
        end-placeholder="结束时间"
        unlink-panels
        :locale="locale"
        @change="timeChange"
      />
    </el-config-provider>
  </div>
</template>

<script lang="ts">
import {
  reactive,
  onBeforeMount,
  onMounted,
  ref,
  toRefs,
  watchEffect,
} from "vue";
import { ElConfigProvider } from "element-plus";
import zhCn from "element-plus/dist/locale/zh-cn.mjs";
import dayjs from "dayjs";
import utcDayjsPlngin from "dayjs/plugin/utc";
dayjs.extend(utcDayjsPlngin);
export default {
  name: "time",
  props: {
    timeType: Number,
    beginAt: String,
    endAt: String,
    activeBtn: {
      type: Number,
      default: 0,
    },
    showGroup: {
      type: Boolean,
      default: true,
    },
    placeholder: {
      type: Array,
      default: ["开始日期", "结束日期"],
    },
    isUtcMode: {
      type: Boolean,
      default: true,
    },
    isDateRangePicker: {
      type: Boolean,
      default: false,
    },
    isCheckToday: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    ElConfigProvider,
  },
  emits: ["selectedTime"],
  setup(props: any, context: any) {
    const data: any = reactive({
      time: [props.beginAt, props.endAt],
      year: "",
      beginTime: props.beginAt ? props.beginAt : undefined,
      endTime: props.endAt ? props.endAt : undefined,
      show: props.showGroup,
      placeholderList: props.placeholder,
    });
    const today = ref("");
    const activeBtn = ref(props.activeBtn);
    const btnList = ref([
      {
        id: 0,
        name: "开累",
      },
      {
        id: 1,
        name: "上月",
      },
      {
        id: 2,
        name: "本月",
      },
      {
        id: 3,
        name: "去年",
      },
      {
        id: 4,
        name: "今年",
      },
    ]);
    const refData: any = toRefs(data);
    onBeforeMount(() => {
      const date = new Date();
      refData.year.value = date.getFullYear();
      const y = date.getFullYear().toString();
      const m = (date.getMonth() + 1).toString().padStart(2, "0");
      const d = date.getDate().toString().padStart(2, "0");
      // today.value = y + "/" + m + "/" + d;
      // data.time = ["1990-01-01", y + "-" + m + "-" + d];
    });
    onMounted(() => {});

    const formatFun = (date, format) => {
      var o: any = {
        "M+": date.getMonth() + 1, //month
        "d+": date.getDate(), //day
        "h+": date.getHours(), //hour
        "m+": date.getMinutes(), //minute
        "s+": date.getSeconds(), //second
        "q+": Math.floor((date.getMonth() + 3) / 3), //quarter
        S: date.getMilliseconds(), //millisecond
      };
      if (/(y+)/.test(format))
        format = format.replace(
          RegExp.$1,
          (date.getFullYear() + "").substr(4 - RegExp.$1.length)
        );
      for (var k in o)
        if (new RegExp("(" + k + ")").test(format))
          format = format.replace(
            RegExp.$1,
            RegExp.$1.length == 1
              ? o[k]
              : ("00" + o[k]).substr(("" + o[k]).length)
          );
      return format;
    };

    const timeChange = (dates: any | String) => {
      activeBtn.value = -1;
      if (dates) {
        if (props.isUtcMode) {
          context.emit(
            "selectedTime",
            dates[0] ? dayjs(dates[0]).utc().format() : undefined,
            dates[1] ? dayjs(dates[1]).utc().format() : undefined,
            props.timeType
          );
        } else {
          context.emit("selectedTime", dates[0], dates[1], props.timeType);
        }
      } else {
        context.emit("selectedTime", null, null, props.timeType);
      }
    };
    const selectTime = (e: any) => {
      console.log(props.timeType);

      let type = e.target.value;
      if (type === 0) {
        //开累
        refData.beginTime.value = "1990/01/01";
        refData.endTime.value = today.value;
      } else if (type === 1) {
        //上月
        refData.beginTime.value = formatFun(
          new Date(
            new Date(new Date().setMonth(new Date().getMonth() - 1)).setDate(1)
          ),
          "yyyy/MM/dd"
        );
        refData.endTime.value = formatFun(
          new Date(new Date().setDate(0)),
          "yyyy/MM/dd"
        );
      } else if (type === 2) {
        //本月
        refData.beginTime.value = formatFun(
          new Date(new Date().setDate(1)),
          "yyyy/MM/dd"
        );
        refData.endTime.value = formatFun(
          new Date(
            new Date(new Date().setMonth(new Date().getMonth() + 1)).setDate(0)
          ),
          "yyyy/MM/dd"
        );
      } else if (type === 3) {
        //去年
        refData.beginTime.value = `${new Date().getFullYear() - 1}/01/01`;
        refData.endTime.value = `${new Date().getFullYear() - 1}/12/31`;
      } else if (type === 4) {
        //今年
        refData.beginTime.value = formatFun(
          new Date(new Date(new Date().setMonth(0)).setDate(1)),
          "yyyy/MM/dd"
        );
        refData.endTime.value = formatFun(
          new Date(new Date(new Date().setMonth(12)).setDate(0)),
          "yyyy/MM/dd"
        );
      }
      refData.time.value = [refData.beginTime.value, refData.endTime.value];
      if (props.isUtcMode) {
        dayjs(refData.beginTime.value).utc().format();
        console.log(
          refData.beginTime.value
            ? dayjs(refData.beginTime.value).utc().format()
            : undefined,
          refData.endTime.value
            ? dayjs(refData.endTime.value).utc().format()
            : undefined,
          props.timeType,
          "-----------------------selectedTime"
        );
        context.emit(
          "selectedTime",
          refData.beginTime.value
            ? dayjs(refData.beginTime.value).utc().format()
            : undefined,
          refData.endTime.value
            ? dayjs(refData.endTime.value).utc().format()
            : undefined,
          props.timeType
        );
      } else {
        console.log(
          refData.beginTime.value,
          refData.endTime.value,
          props.timeType,
          "-----------------------selectedTime"
        );
        context.emit(
          "selectedTime",
          refData.beginTime.value,
          refData.endTime.value,
          props.timeType
        );
      }
    };
    watchEffect(async () => {
      // if(props.beginAt){
      //   activeBtn.value = -1
      // }else{
      //   activeBtn.value = 0
      // }
      data.beginTime = props.beginAt ?? undefined;
      data.endTime = props.endAt ?? undefined;
      data.time = [props.beginAt, props.endAt];
    });
    return {
      ...refData,
      activeBtn,
      btnList,
      timeChange,
      selectTime,
      locale: zhCn,
      dayjs
    };
  },
};
</script>
<style lang="scss" scoped>
:deep(.el-input__prefix) {
  display: none !important;
}
:deep(.el-input__wrapper) {
  font-size: 13px !important;
}
.Mrp-time {
  .active {
    background: rgba(189, 158, 85, 1);
  }

  :deep(.ant-radio-button-wrapper:first-child) {
    border-radius: 4px 0 0 4px;
  }

  :deep(.ant-radio-button-wrapper:last-child) {
    border-radius: 0 4px 4px 0;
  }
  :deep(.el-date-editor .el-range-input) {
    font-size: 12px;
    color: #333333;
  }
  :deep(.ant-radio-button-wrapper) {
    width: 52px;
    height: 30px;
    font-size: 12px;
    color: #006ab2;
    padding: 0;
    text-align: center;
    line-height: 30px;
    border: 1px solid rgba(0, 106, 178, 1);
  }
  :deep(.ant-radio-button-wrapper-checked) {
    background: rgba(189, 158, 85, 1);
    color: #fff;
    border: 1px solid rgba(189, 158, 85, 1);
  }
  :deep(
      .ant-radio-button-wrapper-checked:not(
          .ant-radio-button-wrapper-disabled
        ):first-child
    ) {
    border-color: rgba(189, 158, 85, 1);
  }
}
:deep(.el-picker-panel__icon-btn) {
  margin-top: 0;
}
</style>
